import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import MailIcon from "@material-ui/icons/Mail";
import "../../style.css";
import uploadNavImg from "images/upload_navbar.png";
import uploadProgImg from "images/checklist_navbar.png";
import passImg from "images/check_navbar.png";
import failImg from "images/cross_navbar.png";
import chartImg from "images/chart_navbar.png";
import logoutImg from "images/warning_navbar.png";
import schduleImg from "images/notebook_purple.png";
import truckImg from "images/truck_img.png";
import TechnicalSupportIcon from "images/Techinal_Support_Icon.svg";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ReportIcon from '@material-ui/icons/Report';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import {
  eInvRoutes,
  anx1Routes,
  ewayBillRoutes,
  // manageProfile,
  gstrRoutes,
  gstr1NewRoutes,
  gstr3bRoutes,
  adminRoutes,
  superAdminRoutes,
  B2CRoutes,
  gstr9NewRoutes,
  gstr9CRoutes,
  gstr9CNewRoutes,
  dataFetchRoutes,
  dataFetchSubRoutes,
  AllModuleRoutes,
  AnalyticsModuleRoutes,
  // NoActiveModuleRoutes,
  SupplierModuleRoutes,
  gstr7Routes,
  gstr8Routes,
  gstr6Routes,
  itc04Routes,
  gstr2XRoutes,
  ReturnsRoutes,
  NotReturnsRoutes,
  IMSRoutes,
  ewayBillRecoRoutes,
  HelpAndSupport,
  ImsRecoRoutes,
  gstr2a2bNewRoutes,
   noteRoutes,
   noticeRoute,
   externalLinks,
   templateMapping,
   chatBotRoutes
} from "../routes";
// import { Link, withRouter, Switch, Route, NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import gtLogo from "images/gt_logo.svg";
// import back01 from "images/back-01.jpg";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import LockIcon from "@material-ui/icons/Lock";
import ReceiptIcon from "@material-ui/icons/Receipt";
import Avatar from "@material-ui/core/Avatar";
import { setIsOpen } from "./actions";
import { useDispatch, useSelector } from "react-redux";
import {
  // saveLocalStorage,
  // getToken,
  getLocalStorage,
  removeLocalStorage,
} from "components/Helper/Helper";
// import { useEffect } from "react";
import { setDefault } from "containers/gstr3b/Gstr3bFilterComponent/action";
import { TreeItem, TreeView } from "@material-ui/lab";
import "./treeView.css"
import { useLocation } from "react-router-dom";
import { Collapse,Button } from "@material-ui/core";
import AddNotes from "containers/Notes_module/PopUp/AddNotes";
import { setModuleIds, setOpenAddNotes } from "containers/Notes_module/Notes/action";
import CreateIcon from '@material-ui/icons/Create';
import AssistModeDropdown from "containers/ChatBot/AssistModeDropdown";
const drawerWidth = 200;

const SmartToyIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="#4F2D7F">
    <path d="M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zM7.5 11.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S9.83 13 9 13s-1.5-.67-1.5-1.5zM16 17H8v-2h8v2zm-1-4c-.83 0-1.5-.67-1.5-1.5S14.17 10 15 10s1.5.67 1.5 1.5S15.83 13 15 13z"/>
  </svg>
);

function removeLocal(props) {
  props.history.push("/");
  removeLocalStorage("loginDetails");
}
function backToLanding(props, from = false) {
  props.history.push("/landing");
}
function logout(props) {
  props.history.push("/logout");
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.appBar,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: "#4f2d7f",
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: "0px", //   theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: "0px", // width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    width: `calc(100% - ${drawerWidth}px)`,
    padding: theme.spacing(3),
  },
}));



export default function MiniDrawer(props) {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const open = useSelector((state) => state.SidebarReducer.drawerIsOpen);
  const [expanded, setExpanded] = React.useState("panel1");
  const [expanded1, setExpanded1] = React.useState("panel2");
  const [openReport, setOpenReport] = React.useState(false);
  const [moduleIds, setModuleIds] = useState([]);
  const [isReturn, setIsReturn] = useState(false);

    const location = useLocation();

  const handleClick = () => {
    setOpenReport(!openReport);
  };
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleChange1 = (panel) => (event, isExpanded) => {
    setExpanded1(isExpanded ? panel : false);
  };

  const handleDrawerOpen = () => {
    dispatch(setIsOpen(true));
    // setOpen(true);
  };

  const handleDrawerClose = () => {
    dispatch(setIsOpen(false));
    // setOpen(false);
  };


  useEffect(()=>{
    const returnRouteIDs = ReturnsRoutes?.map(route => route.moduleId) || [];
    let isReturns = false;
    if (props.modules && returnRouteIDs?.length > 0) {
      for (let i = 0; i < props.modules.length; i++) {
        if (returnRouteIDs.includes(props.modules[i].moduleId)) {
          isReturns = true;
          break;
        }
      }
    }
      setIsReturn(isReturns);
     
  },[props.modules])

  const anx1RoutesImage = [
    uploadNavImg,
    uploadProgImg,
    passImg,
    schduleImg,
    truckImg,
    chartImg,
    logoutImg,
  ];
  const arrImage = [
    uploadNavImg,
    uploadProgImg,
    passImg,
    schduleImg,
    failImg,
    truckImg,
    chartImg,
    uploadProgImg,
    schduleImg,
    logoutImg,
  ];
  const eInvImage = [
    uploadNavImg,
    uploadProgImg,
    passImg,
    schduleImg,
    truckImg,
    failImg,
    chartImg,
    uploadProgImg,
    schduleImg,
    uploadProgImg,
  ];
  const gstr1Image = [uploadNavImg, uploadProgImg, passImg, logoutImg];
  const gstr3bImage = [uploadNavImg, uploadProgImg, logoutImg];
  const ewaybillImage = [uploadNavImg, truckImg, passImg, chartImg, logoutImg];
  const invImage = [
    uploadProgImg,
    schduleImg,
    uploadNavImg,
    passImg,
    uploadNavImg,
    truckImg,
    chartImg,
    uploadProgImg,
  ];
  const adminImage = [uploadNavImg, logoutImg];
  const gstr9Image = [uploadProgImg, passImg, logoutImg];

  const renderMenuItems = (route, index) => {
    if (route.name === 'Report') {
      return (
        <TreeView
          key={route.name}
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          className={route.activeList.includes(window.location.pathname) ? 'sideBar-active' : ''}
        >
          <TreeItem nodeId="1" label="Report">
            {route.subRoutes.map((subRoute, subIndex) => (
              <TreeItem
                key={subRoute.name}
                nodeId={`2-${subIndex}`}
                label={
                  <Link to={subRoute.path} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Typography
                      style={{
                        fontSize: '13px',
                        fontFamily: 'GT-Walsheim-medium',
                        color: 'rgb(79 45 127)',
                      }}
                    >
                      {subRoute.name}
                    </Typography>
                  </Link>
                }
              />
            ))}
          </TreeItem>
        </TreeView>
      );
    } else {
      return (
        <div key={route.name} className={route.activeList.includes(window.location.pathname) ? 'sideBar-active' : ''}>
          <ListItem
            component={Link}
            to={route.path}
            style={{
              textDecoration: 'none',
              whiteSpace: 'pre-line',
            }}
          >
            <ListItemText
              primary={
                <Typography
                  style={{
                    fontSize: '13px',
                    fontFamily: 'GT-Walsheim-medium',
                    color: 'rgb(79 45 127)',
                  }}
                >
                  {route.name}
                </Typography>
              }
            />
          </ListItem>
        </div>
      );
    }
  };
const handleOpenAddNotes = () => {
  dispatch(setOpenAddNotes(true));
}
const includeModules = [
  "imsReco",
  "gstr2a2bNew",
  "ims",
  "gstr1New",
  "gstr3b",
  "gstr9_new",
  "gstr7",
  "itc04",
  "gstr6",
  "gstr2X",
  "gstr8"
];
  return (
    <div className={classes.root}>
      <CssBaseline />

      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open && !props.showNavBar,
        })}
      >
        <Toolbar
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginRight: "24px",
          }}
        >
          {!props.showNavBar && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(classes.menuButton, {
                [classes.hide]: open,
              })}
            >
              <MenuIcon />
            </IconButton>
          )}
          {props.module === "chat_bot" ? (
            <AssistModeDropdown label={props.currentPage} />
          ) : 
          (<Typography
            variant="h6"
            style={{
              fontFamily: "GT-Walsheim-medium",
            }}
            noWrap
          >
            {props.currentPage}
          </Typography>)}

          <div class="dropdown show">
            {/* <a
              class="nav-link dropdown-toggle noBg"
              href="#"
              role="button"
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            > */}
              <Avatar
                style={{
                  left: "90%",
                  backgroundColor: "rgb(114, 87, 153)",
                  cursor:'pointer'
                }}
              >
                {getLocalStorage("userInfo")}
              </Avatar>
            {/* </a> */}

            <div
              class="dropdown-menu"
              aria-labelledby="dropdownMenuLink"
              style={{ marginLeft: "-124px" }}
            >
              {props.module != "admin" && (
                <a
                  class="dropdown-item"
                  style={{ cursor: "pointer", backgroundColor: "white" }}
                  href="/ProfilePage"
                >
                  <AccountCircleIcon /> Manage Profile
                </a>
              )}

              <a
                class="dropdown-item"
                style={{ cursor: "pointer", backgroundColor: "white" }}
                onClick={() => props.changePassword()}
              >
                <LockIcon /> Change Password
              </a>

              <div class="dropdown show">
                {props.module != "admin" && (
                  <a
                    class="dropdown-item"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ cursor: "pointer", backgroundColor: "white" }}
                  >
                    <ReceiptIcon /> Utilities
                  </a>
                )}

                <div class="dropdown-menu" style={{ width: "100%" }}>
                  <a
                    class="dropdown-item"
                    href="/invoiceDetail"
                    style={{ cursor: "pointer", backgroundColor: "white" }}
                  >
                    <ReceiptIcon /> Invoice Details
                  </a>
                  <a
                    class="dropdown-item"
                    href="/fetchGstnDetail"
                    style={{ cursor: "pointer", backgroundColor: "white" }}
                  >
                    <ReceiptIcon /> Supplier Details
                  </a>
                  <a
                    class="dropdown-item"
                    href="/external_links"
                    style={{ cursor: "pointer", backgroundColor: "white" }}
                  >
                    <ReceiptIcon /> Knowledge Hub
                  </a>
                  <a
                    class="dropdown-item"
                    href="/template_mapping"
                    style={{ cursor: "pointer", backgroundColor: "white" }}
                  >
                    <ReceiptIcon /> Template Mapping
                  </a>
                </div>
              </div>

              <a
                class="dropdown-item"
                href="/logout"
                style={{ cursor: "pointer", backgroundColor: "white" }}
              >
                <PowerSettingsNewIcon /> Logout
              </a>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      {!props.showNavBar && (
        <Drawer
          variant="permanent"
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            }),
          }}
        >
          <div className={classes.toolbar}>
            <div
              onClick={() => {
                if (!props.cardsPage && props.module != "admin") {
                  dispatch(setDefault())
                  backToLanding(props);
                }
              }}
              style={{ cursor: "pointer" }}
            >
              <img
                src={gtLogo}
                alt="Logo"
                style={{ width: "100%", paddingLeft: "6%" }}
              />
            </div>
            <IconButton onClick={handleDrawerClose}>
              <MenuIcon />
            </IconButton>
          </div>
          <div style={{display:'flex', flexDirection:"column", justifyContent:'space-between', height:"100%"}}>
          <List>
            {props.module == "eInv" ? (
              <div>
                {eInvRoutes.map((prop, index) => (
                  <div>
                    {prop.name != "Logout" ? (
                      <div
                        className={
                          prop.path == window.location.pathname
                            ? "sideBar-active"
                            : ""
                        }
                      >
                        <ListItem
                          key={prop.name}
                          component={Link}
                          to={prop.path}
                          style={{
                            textDecoration: "none",
                            whiteSpace: "pre-line",
                          }}
                        >
                          <ListItemText
                            primary={
                              <Typography
                                style={{
                                  fontSize: "13px",
                                  fontFamily: "GT-Walsheim-medium",
                                  color: "rgb(79 45 127)",
                                }}
                              >
                                {prop.name}
                              </Typography>
                            }
                          />
                        </ListItem>
                      </div>
                    ) : (
                      <ListItem
                        key={prop.name}
                        component={Link}
                        to={prop.path}
                        style={{
                          textDecoration: "none",
                          whiteSpace: "pre-line",
                        }}
                      >
                        <ListItemText
                          primary={
                            <Typography
                              style={{
                                fontSize: "13px",
                                fontFamily: "GT-Walsheim-medium",
                                color: "rgb(79 45 127)",
                              }}
                            >
                              {prop.name}
                            </Typography>
                          }
                        />
                      </ListItem>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div>
                {props.module == "b2c" ? (
                  <div>
                    {B2CRoutes.map((prop, index) => (
                      <div
                        className={
                          prop.path == window.location.pathname
                            ? "sideBar-active"
                            : ""
                        }
                      >
                        <ListItem
                          key={prop.name}
                          component={Link}
                          to={prop.path}
                          style={{
                            textDecoration: "none",
                            whiteSpace: "pre-line",
                          }}
                        >
                          <ListItemText
                            primary={
                              <Typography
                                style={{
                                  fontSize: "13px",
                                  fontFamily: "GT-Walsheim-medium",
                                  color: "rgb(79 45 127)",
                                }}
                              >
                                {prop.name}
                              </Typography>
                            }
                          />
                        </ListItem>
                      </div>
                    ))}
                  </div>
                ) : props.module == "eWay" ? (
                  <div>
                    {ewayBillRoutes.map((prop, index) => (
                      <div
                        className={
                          prop.path == window.location.pathname
                            ? "sideBar-active"
                            : ""
                        }
                      >
                        <ListItem
                          key={prop.name}
                          component={Link}
                          to={prop.path}
                          style={{
                            textDecoration: "none",
                            whiteSpace: "pre-line",
                          }}
                        >
                          <ListItemText
                            primary={
                              <Typography
                                style={{
                                  fontSize: "13px",
                                  fontFamily: "GT-Walsheim-medium",
                                  color: "rgb(79 45 127)",
                                }}
                              >
                                {prop.name}
                              </Typography>
                            }
                          />
                        </ListItem>
                      </div>
                    ))}
                  </div>
                ) : props.module == "ewb_reco" ? (
                  <div>
                    {ewayBillRecoRoutes.map((prop, index) => (
                      <div
                        className={
                          prop.path == window.location.pathname
                            ? "sideBar-active"
                            : ""
                        }
                      >
                        <ListItem
                          key={prop.name}
                          component={Link}
                          to={prop.path}
                          style={{
                            textDecoration: "none",
                            whiteSpace: "pre-line",
                          }}
                        >
                          <ListItemText
                            primary={
                              <Typography
                                style={{
                                  fontSize: "13px",
                                  fontFamily: "GT-Walsheim-medium",
                                  color: "rgb(79 45 127)",
                                }}
                              >
                                {prop.name}
                              </Typography>
                            }
                          />
                        </ListItem>
                      </div>
                    ))}
                  </div>
                ) : props.module == "profile" ? (
                  // <div>
                  //   {AllModuleRoutes.map((prop, index) => (
                  //     <div>
                  //       {props.modules &&
                  //         props.modules.length != 0 &&
                  //         props.modules.map((item) => {
                  //           if (item.moduleId == prop.moduleId) {
                  //             return (
                  //               <>
                  //                 <ListItem
                  //                   key={prop.name}
                  //                   component={Link}
                  //                   to={prop.path}
                  //                   style={{
                  //                     textDecoration: "none",
                  //                     whiteSpace: "pre-line",
                  //                   }}
                  //                 >
                  //                   <ListItemText
                  //                     primary={
                  //                       <Typography
                  //                         style={{
                  //                           fontSize: "13px",
                  //                           fontFamily: "GT-Walsheim-medium",
                  //                           color: "rgb(79 45 127)",
                  //                         }}
                  //                       >
                  //                         {prop.name}
                  //                       </Typography>
                  //                     }
                  //                   />
                  //                 </ListItem>
                  //               </>
                  //             );
                  //           } else {
                  //             <></>;
                  //           }
                  //         })}
                  //     </div>
                  //   ))}
                  // </div>
                  
                  <div>
                  {NotReturnsRoutes.map((prop, index) => (
                    <div>
                      {props.modules &&
                        props.modules.length != 0 &&
                        props.modules.map((item) => {
                          if (item.moduleId == prop.moduleId) {
                            return (
                              <>
                                <ListItem
                                  key={prop.name}
                                  component={Link}
                                  to={prop.path}
                                  style={{
                                    textDecoration: "none",
                                    whiteSpace: "pre-line",
                                  }}
                                >
                                  <ListItemText
                                    primary={
                                      <Typography
                                        style={{
                                          fontSize: "13px",
                                          fontFamily: "GT-Walsheim-medium",
                                          color: "rgb(79 45 127)",
                                        }}
                                      >
                                        {prop.name}
                                      </Typography>
                                    }
                                  />
                                </ListItem>
                              </>
                            );
                          } else {
                            <></>;
                          }
                        })}
                    </div>
                  ))}
                  {props.modules &&
                        props.modules.length != 0 && isReturn &&
                  <div>
                  <ListItem                  
                         style={{
                           textDecoration: "none",
                           whiteSpace: "pre-line",
                         }}
                       >
        <ListItemText 
                             primary={
                               <Typography
                                 style={{
                                   fontSize: "13px",
                                   fontFamily: "GT-Walsheim-medium",
                                   color: "rgb(79 45 127)",
                                   // paddingLeft:'1em',
                                  
                                 }}
                                 
                               >
                                 Returns
                               </Typography>
                             }
                           />
      {openReport ? <ExpandLessIcon onClick={handleClick} style={{marginRight:'3em'}}/> : <ExpandMoreIcon onClick={handleClick} style={{marginRight:'3.5em'}} />}

                           </ListItem>
          <Collapse in={openReport} timeout="auto" 
      unmountOnExit
      >
        <List component="div" disablePadding>
         
                          
              <List>
        {ReturnsRoutes.map((prop, index) => (
                    <div>
                      {props.modules &&
                        props.modules.length != 0 &&
                        props.modules.map((item) => {
                          if (item.moduleId == prop.moduleId) {
                            return (
                              <>
                                <ListItem
                                  key={prop.name}
                                  component={Link}
                                  to={prop.path}
                                  style={{
                                    textDecoration: "none",
                                    whiteSpace: "pre-line",
                                  }}
                                >
                                  <ListItemText
                                    primary={
                                      <Typography
                                        style={{
                                          fontSize: "13px",
                                          fontFamily: "GT-Walsheim-medium",
                                          color: "rgb(79 45 127)",
                                        }}
                                      >
                                        {prop.name}
                                      </Typography>
                                    }
                                  />
                                </ListItem>
                              </>
                            );
                          } else {
                            <></>;
                          }
                        })}
                    </div>
                  ))}
      </List>
            
            
        </List>
      </Collapse>
          <Divider />
                </div>}
                </div>
                
                ) : props.module == "gstin" ? (
                  <div>
                    {SupplierModuleRoutes.map((prop, index) => (
                      <div>
                        {prop.name != "Logout" ? (
                          <div
                            className={
                              prop.path == window.location.pathname
                                ? "sideBar-active"
                                : ""
                            }
                          >
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "13px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          </div>
                        ) : (
                          <ListItem
                            key={prop.name}
                            component={Link}
                            to={prop.path}
                            style={{
                              textDecoration: "none",
                              whiteSpace: "pre-line",
                            }}
                          >
                            <ListItemText
                              primary={
                                <Typography
                                  style={{
                                    fontSize: "13px",
                                    fontFamily: "GT-Walsheim-medium",
                                    color: "rgb(79 45 127)",
                                  }}
                                >
                                  {prop.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </div>
                ) : props.module == "anx1" ? (
                  <div>
                    {anx1Routes.map((prop, index) => (
                      <div>
                        {prop.name != "Logout" ? (
                          <div
                            className={
                              prop.path == window.location.pathname
                                ? "sideBar-active"
                                : ""
                            }
                          >
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              {/* <ListItemIcon>
                              <img
                                src={anx1RoutesImage[index]}
                                alt="Logo"
                                style={{ width: "35px" }}
                              />
                            </ListItemIcon> */}
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "13px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          </div>
                        ) : (
                          <ListItem
                            key={prop.name}
                            component={Link}
                            to={prop.path}
                            style={{
                              textDecoration: "none",
                              whiteSpace: "pre-line",
                            }}
                          >
                            <ListItemText
                              primary={
                                <Typography
                                  style={{
                                    fontSize: "13px",
                                    fontFamily: "GT-Walsheim-medium",
                                    color: "rgb(79 45 127)",
                                  }}
                                >
                                  {prop.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </div>
                ) : props.module == "gstr1" ? (
                  <div>
                    {gstrRoutes.map((prop, index) => (
                      <div>
                        {prop.name != "Logout" ? (
                          <div
                            className={
                              prop.path == window.location.pathname
                                ? "sideBar-active"
                                : ""
                            }
                          >
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          </div>
                        ) : (
                          <ListItem
                            key={prop.name}
                            component={Link}
                            to={prop.path}
                            style={{
                              textDecoration: "none",
                              whiteSpace: "pre-line",
                            }}
                          >
                            <ListItemText
                              primary={
                                <Typography
                                  style={{
                                    fontSize: "12px",
                                    fontFamily: "GT-Walsheim-medium",
                                    color: "rgb(79 45 127)",
                                  }}
                                >
                                  {prop.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </div>
                ) : props.module == "gstr1New" ? (
                  <div>
                    {gstr1NewRoutes.map((prop, index) => (
                      <div>
                        {prop.name != "Logout" ? (
                          <div
                            className={
                              prop.path == window.location.pathname
                                ? "sideBar-active"
                                : ""
                            }
                          >
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          </div>
                        ) : (
                          <ListItem
                            key={prop.name}
                            component={Link}
                            to={prop.path}
                            style={{
                              textDecoration: "none",
                              whiteSpace: "pre-line",
                            }}
                          >
                            <ListItemText
                              primary={
                                <Typography
                                  style={{
                                    fontSize: "12px",
                                    fontFamily: "GT-Walsheim-medium",
                                    color: "rgb(79 45 127)",
                                  }}
                                >
                                  {prop.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </div>
                ) : props.module == "gstr2a2bNew" ? (
                    <div>
                      {gstr2a2bNewRoutes.map((prop, index) => (
                        <div>
                          {prop.name != "Logout" ? (
                            <div
                              className={
                                prop.path == window.location.pathname
                                  ? "sideBar-active"
                                  : ""
                              }
                            >
                              <ListItem
                                key={prop.name}
                                component={Link}
                                to={prop.path}
                                style={{
                                  textDecoration: "none",
                                  whiteSpace: "pre-line",
                                }}
                              >
                                <ListItemText
                                  primary={
                                    <Typography
                                      style={{
                                        fontSize: "12px",
                                        fontFamily: "GT-Walsheim-medium",
                                        color: "rgb(79 45 127)",
                                      }}
                                    >
                                      {prop.name}
                                    </Typography>
                                  }
                                />
                              </ListItem>
                            </div>
                          ) : (
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          )}
                        </div>
                      ))}
                    </div>
                  )
                   : props.module == "imsReco" ? (
                  <div>
                    {ImsRecoRoutes.map((section, index) => {
                      // Case 1: Section with subRoutes (grouped menu)
                      if (
                        section.subRoutes &&
                        Array.isArray(section.subRoutes)
                      ) {
                        const isActiveSection = section.activeList?.includes(
                          location.pathname
                        );

                        return (
                          <div key={index} className="mb-2">
                            {/* Group Header */}
                            <div
                              className={
                                isActiveSection ? "sideBar-active" : ""
                              }
                              style={{
                                padding: "6px 12px",
                                fontWeight: "bold",
                              }}
                            >
                              <Typography
                                style={{
                                  fontSize: "13px",
                                  fontFamily: "GT-Walsheim-medium",
                                  color: "rgb(79 45 127)",
                                }}
                              >
                                {section.name}
                              </Typography>
                            </div>

                            {/* SubRoutes */}
                            {section.subRoutes.map((sub, subIndex) => {
                              const isActiveSub =
                                location.pathname === sub.path;

                              return (
                                <ListItem
                                  key={sub.path}
                                  component={Link}
                                  to={sub.path}
                                  className={
                                    isActiveSub ? "sideBar-active" : ""
                                  }
                                  style={{
                                    textDecoration: "none",
                                    whiteSpace: "pre-line",
                                    paddingLeft: "24px",
                                  }}
                                >
                                  <ListItemText
                                    primary={
                                      <Typography
                                        style={{
                                          fontSize: "12px",
                                          fontFamily: "GT-Walsheim-medium",
                                          color: "rgb(79 45 127)",
                                        }}
                                      >
                                        {sub.name}
                                      </Typography>
                                    }
                                  />
                                </ListItem>
                              );
                            })}
                          </div>
                        );
                      }

                      // Case 2: Direct route (no subRoutes)
                      const isActiveDirect = location.pathname === section.path;

                      return (
                        <ListItem
                          key={section.path}
                          component={Link}
                          to={section.path}
                          className={isActiveDirect ? "sideBar-active" : ""}
                          style={{
                            textDecoration: "none",
                            whiteSpace: "pre-line",
                            padding: "6px 12px",
                          }}
                        >
                          <ListItemText
                            primary={
                              <Typography
                                style={{
                                  fontSize: "13px",
                                  fontFamily: "GT-Walsheim-medium",
                                  color: "rgb(79 45 127)",
                                }}
                              >
                                {section.name}
                              </Typography>
                            }
                          />
                        </ListItem>
                      );
                    })}
                  </div>
                )
                :props.module == "chat_bot" ? (
                    <div>
                      {chatBotRoutes.map((prop, index) => (
                        <div>
                          {prop.name != "Logout" ? (
                            <div
                              className={
                                prop.path == window.location.pathname
                                  ? "sideBar-active"
                                  : ""
                              }
                            >
                              <ListItem
                                key={prop.name}
                                component={Link}
                                to={prop.path}
                                style={{
                                  textDecoration: "none",
                                  whiteSpace: "pre-line",
                                }}
                              >
                                {/* <ListItemIcon>
                              <img
                                src={anx1RoutesImage[index]}
                                alt="Logo"
                                style={{ width: "35px" }}
                              />
                            </ListItemIcon> */}
                                <ListItemText
                                  primary={
                                    <Typography
                                      style={{
                                        fontSize: "13px",
                                        fontFamily: "GT-Walsheim-medium",
                                        color: "rgb(79 45 127)",
                                      }}
                                    >
                                      {prop.name}
                                    </Typography>
                                  }
                                />
                              </ListItem>
                            </div>
                          ) : (
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "13px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          )}
                        </div>
                      ))}
                    </div>
                  )
                : props.module == "gstr2X" ? (
                  <div>
                    {gstr2XRoutes.map((prop, index) => (
                      <div>
                        {prop.name != "Logout" ? (
                          <div
                            className={
                              prop.path == window.location.pathname
                                ? "sideBar-active"
                                : ""
                            }
                          >
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              {/* <ListItemIcon>
                              <img
                                src={anx1RoutesImage[index]}
                                alt="Logo"
                                style={{ width: "35px" }}
                              />
                            </ListItemIcon> */}
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "13px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          </div>
                        ) : (
                          <ListItem
                            key={prop.name}
                            component={Link}
                            to={prop.path}
                            style={{
                              textDecoration: "none",
                              whiteSpace: "pre-line",
                            }}
                          >
                            <ListItemText
                              primary={
                                <Typography
                                  style={{
                                    fontSize: "13px",
                                    fontFamily: "GT-Walsheim-medium",
                                    color: "rgb(79 45 127)",
                                  }}
                                >
                                  {prop.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </div>
                ) : props.module == "notes" ? (
                    <div>
                      {noteRoutes.map((prop, index) => (
                        <div>
                          {prop.name != "Logout" ? (
                            <div
                              className={
                                prop.path == window.location.pathname
                                  ? "sideBar-active"
                                  : ""
                              }
                            >
                              <ListItem
                                key={prop.name}
                                component={Link}
                                to={prop.path}
                                style={{
                                  textDecoration: "none",
                                  whiteSpace: "pre-line",
                                }}
                              >
                                {/* <ListItemIcon>
                              <img
                                src={anx1RoutesImage[index]}
                                alt="Logo"
                                style={{ width: "35px" }}
                              />
                            </ListItemIcon> */}
                                <ListItemText
                                  primary={
                                    <Typography
                                      style={{
                                        fontSize: "13px",
                                        fontFamily: "GT-Walsheim-medium",
                                        color: "rgb(79 45 127)",
                                      }}
                                    >
                                      {prop.name}
                                    </Typography>
                                  }
                                />
                              </ListItem>
                            </div>
                          ) : (
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "13px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          )}
                        </div>
                      ))}
                    </div>
                  ) :  props.module == "notice" ? (
                  <div>
                    {noticeRoute.map((prop, index) => (
                      <div>
                        {prop.name != "Logout" ? (
                          <div
                            className={
                              prop.path == window.location.pathname
                                ? "sideBar-active"
                                : ""
                            }
                          >
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              // to={"./Notice/Notice/index.js"}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          </div>
                        ) : (
                          <ListItem
                            key={prop.name}
                            component={Link}
                            to={prop.path}
                            style={{
                              textDecoration: "none",
                              whiteSpace: "pre-line",
                            }}
                          >
                            <ListItemText
                              primary={
                                <Typography
                                  style={{
                                    fontSize: "12px",
                                    fontFamily: "GT-Walsheim-medium",
                                    color: "rgb(79 45 127)",
                                  }}
                                >
                                  {prop.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </div>
                ):props.module == "template_mapping" ? (
                    <div>
                      {templateMapping.map((prop, index) => (
                        <div>
                          {prop.name != "Logout" ? (
                            <div
                              className={
                                prop.path == window.location.pathname
                                  ? "sideBar-active"
                                  : ""
                              }
                            >
                              <ListItem
                                key={prop.name}
                                component={Link}
                                to={prop.path}
                                style={{
                                  textDecoration: "none",
                                  whiteSpace: "pre-line",
                                }}
                              >
                                {/* <ListItemIcon>
                              <img
                                src={anx1RoutesImage[index]}
                                alt="Logo"
                                style={{ width: "35px" }}
                              />
                            </ListItemIcon> */}
                                <ListItemText
                                  primary={
                                    <Typography
                                      style={{
                                        fontSize: "13px",
                                        fontFamily: "GT-Walsheim-medium",
                                        color: "rgb(79 45 127)",
                                      }}
                                    >
                                      {prop.name}
                                    </Typography>
                                  }
                                />
                              </ListItem>
                            </div>
                          ) : (
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "13px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : props.module == "itc04" ? (
                  <div>
                    {itc04Routes.map((prop, index) => (
                      <div>
                        {prop.name != "Logout" ? (
                          <div
                            className={
                              prop.path == window.location.pathname
                                ? "sideBar-active"
                                : ""
                            }
                          >
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              {/* <ListItemIcon>
                              <img
                                src={anx1RoutesImage[index]}
                                alt="Logo"
                                style={{ width: "35px" }}
                              />
                            </ListItemIcon> */}
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "13px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          </div>
                        ) : (
                          <ListItem
                            key={prop.name}
                            component={Link}
                            to={prop.path}
                            style={{
                              textDecoration: "none",
                              whiteSpace: "pre-line",
                            }}
                          >
                            <ListItemText
                              primary={
                                <Typography
                                  style={{
                                    fontSize: "13px",
                                    fontFamily: "GT-Walsheim-medium",
                                    color: "rgb(79 45 127)",
                                  }}
                                >
                                  {prop.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </div>
                ): props.module == "gstr6" ? (
                  <div>
                    {gstr6Routes.map((prop, index) => (
                      <div>
                        {prop.name != "Logout" ? (
                          <div
                            className={
                              prop.path == window.location.pathname
                                ? "sideBar-active"
                                : ""
                            }
                          >
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          </div>
                        ) : (
                          <ListItem
                            key={prop.name}
                            component={Link}
                            to={prop.path}
                            style={{
                              textDecoration: "none",
                              whiteSpace: "pre-line",
                            }}
                          >
                            <ListItemText
                              primary={
                                <Typography
                                  style={{
                                    fontSize: "12px",
                                    fontFamily: "GT-Walsheim-medium",
                                    color: "rgb(79 45 127)",
                                  }}
                                >
                                  {prop.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </div>
                ) : props.module == "gstr7" ? (
                  <div>
                    {gstr7Routes.map((prop, index) => (
                      <div>
                        {prop.name != "Logout" ? (
                          <div
                            className={
                              prop.path == window.location.pathname
                                ? "sideBar-active"
                                : ""
                            }
                          >
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          </div>
                        ) : (
                          <ListItem
                            key={prop.name}
                            component={Link}
                            to={prop.path}
                            style={{
                              textDecoration: "none",
                              whiteSpace: "pre-line",
                            }}
                          >
                            <ListItemText
                              primary={
                                <Typography
                                  style={{
                                    fontSize: "12px",
                                    fontFamily: "GT-Walsheim-medium",
                                    color: "rgb(79 45 127)",
                                  }}
                                >
                                  {prop.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </div>
                )  : props.module == "gstr8" ? (
                  <div>
                    {gstr8Routes.map((prop, index) => (
                      <div>
                        {prop.name != "Logout" ? (
                          <div
                            className={
                              prop.path == window.location.pathname
                                ? "sideBar-active"
                                : ""
                            }
                          >
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          </div>
                        ) : (
                          <ListItem
                            key={prop.name}
                            component={Link}
                            to={prop.path}
                            style={{
                              textDecoration: "none",
                              whiteSpace: "pre-line",
                            }}
                          >
                            <ListItemText
                              primary={
                                <Typography
                                  style={{
                                    fontSize: "12px",
                                    fontFamily: "GT-Walsheim-medium",
                                    color: "rgb(79 45 127)",
                                  }}
                                >
                                  {prop.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </div>
                )
                                
                : props.module == "gstr9_new" ? (
                  <div>
                    <Accordion
                      expanded={expanded == "panel1"}
                      onChange={handleChange("panel1")}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <div style={{ display: "flex" }}>
                          <ListItemText
                            primary={
                              <Typography
                                style={{
                                  fontSize: "12px",
                                  fontFamily: "GT-Walsheim-medium",
                                  color: "rgb(79 45 127)",
                                }}
                              >
                                GSTR-9
                              </Typography>
                            }
                          />
                        </div>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div>
                          {gstr9NewRoutes.map((prop, index) => (
                            <div>
                              {prop.name != "Logout" ? (
                                <div
                                  className={
                                    prop.path == window.location.pathname
                                      ? "sideBar-active"
                                      : ""
                                  }
                                >
                                  <ListItem
                                    key={prop.name}
                                    component={Link}
                                    to={prop.path}
                                    style={{
                                      textDecoration: "none",
                                      whiteSpace: "pre-line",
                                    }}
                                  >
                                    <ListItemText
                                      primary={
                                        <Typography
                                          style={{
                                            fontSize: "12px",
                                            fontFamily: "GT-Walsheim-medium",
                                            color: "rgb(79 45 127)",
                                          }}
                                        >
                                          {prop.name}
                                        </Typography>
                                      }
                                    />
                                  </ListItem>
                                </div>
                              ) : (
                                <ListItem
                                  key={prop.name}
                                  component={Link}
                                  to={prop.path}
                                  style={{
                                    textDecoration: "none",
                                    whiteSpace: "pre-line",
                                  }}
                                >
                                  <ListItemText
                                    primary={
                                      <Typography
                                        style={{
                                          fontSize: "12px",
                                          fontFamily: "GT-Walsheim-medium",
                                          color: "rgb(79 45 127)",
                                        }}
                                      >
                                        {prop.name}
                                      </Typography>
                                    }
                                  />
                                </ListItem>
                              )}
                            </div>
                          ))}
                        </div>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion
                      expanded={expanded1 == "panel2"}
                      onChange={handleChange1("panel2")}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <div style={{ display: "flex" }}>
                          <ListItemText
                            primary={
                              <Typography
                                style={{
                                  fontSize: "12px",
                                  fontFamily: "GT-Walsheim-medium",
                                  color: "rgb(79 45 127)",
                                }}
                              >
                                GSTR-9C
                              </Typography>
                            }
                          />
                        </div>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div>
                          {gstr9CNewRoutes.map((prop, index) => (
                            <div>
                              {prop.name != "Logout" ? (
                                <div
                                  className={
                                    prop.path == window.location.pathname
                                      ? "sideBar-active"
                                      : ""
                                  }
                                >
                                  <ListItem
                                    key={prop.name}
                                    component={Link}
                                    to={prop.path}
                                    style={{
                                      textDecoration: "none",
                                      whiteSpace: "pre-line",
                                    }}
                                  >
                                    <ListItemText
                                      primary={
                                        <Typography
                                          style={{
                                            fontSize: "12px",
                                            fontFamily: "GT-Walsheim-medium",
                                            color: "rgb(79 45 127)",
                                          }}
                                        >
                                          {prop.name}
                                        </Typography>
                                      }
                                    />
                                  </ListItem>
                                </div>
                              ) : (
                                <ListItem
                                  key={prop.name}
                                  component={Link}
                                  to={prop.path}
                                  style={{
                                    textDecoration: "none",
                                    whiteSpace: "pre-line",
                                  }}
                                >
                                  <ListItemText
                                    primary={
                                      <Typography
                                        style={{
                                          fontSize: "12px",
                                          fontFamily: "GT-Walsheim-medium",
                                          color: "rgb(79 45 127)",
                                        }}
                                      >
                                        {prop.name}
                                      </Typography>
                                    }
                                  />
                                </ListItem>
                              )}
                            </div>
                          ))}
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                ) : props.module == "analytics" ? (
                  <div>
                    {AnalyticsModuleRoutes.map((prop, index) => (
                      <div>
                        {prop.name != "Logout" ? (
                          <div
                            className={
                              prop.path == window.location.pathname
                                ? "sideBar-active"
                                : ""
                            }
                          >
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          </div>
                        ) : (
                          <ListItem
                            key={prop.name}
                            component={Link}
                            to={prop.path}
                            style={{
                              textDecoration: "none",
                              whiteSpace: "pre-line",
                            }}
                          >
                            <ListItemText
                              primary={
                                <Typography
                                  style={{
                                    fontSize: "12px",
                                    fontFamily: "GT-Walsheim-medium",
                                    color: "rgb(79 45 127)",
                                  }}
                                >
                                  {prop.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </div>
                ) : props.module == "dataFetch" ? (
                  <div>
                    {dataFetchRoutes.map((prop, index) => (
                      <div>
                        {prop.name != "Logout" ? (
                          <div
                            className={
                              prop.path == window.location.pathname
                                ? "sideBar-active"
                                : ""
                            }
                          >
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                            <Accordion
                              expanded={expanded == "panel1"}
                              onChange={handleChange("panel1")}
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon style={{marginRight:'0.5em'}} />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                              >
                                <div style={{ display: "flex" }}>
                                  <ListItemText
                                    primary={
                                      <Typography
                                        style={{
                                          fontSize: "12px",
                                          fontFamily: "GT-Walsheim-medium",
                                          color: "rgb(79 45 127)",
                                          paddingLeft:'1.4em'
                                        }}
                                      >
                                        Ledger
                                      </Typography>
                                    }
                                  />
                                </div>
                              </AccordionSummary>
                              <AccordionDetails>
                                <div style={{width:'100%'}}>
                                  {dataFetchSubRoutes.map((prop, index) => (
                                    <>
                                      {prop.name != "Logout" ? (
                                        <div
                                          className={
                                            prop.path ==
                                            window.location.pathname
                                              ? "sideBar-active"
                                              : ""
                                          }
                                        >
                                          <ListItem
                                            key={prop.name}
                                            component={Link}
                                            to={prop.path}
                                            style={{
                                              textDecoration: "none",
                                              whiteSpace: "pre-line",
                                            }}
                                          >
                                            <ListItemText
                                              primary={
                                                <Typography
                                                  style={{
                                                    fontSize: "12px",
                                                    fontFamily:
                                                      "GT-Walsheim-medium",
                                                    color: "rgb(79 45 127)",
                                                  }}
                                                >
                                                  {prop.name}
                                                </Typography>
                                              }
                                            />
                                          </ListItem>
                                        </div>
                                      ) : (
                                        <ListItem
                                          key={prop.name}
                                          component={Link}
                                          to={prop.path}
                                          style={{
                                            textDecoration: "none",
                                            whiteSpace: "pre-line",
                                          }}
                                        >
                                          <ListItemText
                                            primary={
                                              <Typography
                                                style={{
                                                  fontSize: "12px",
                                                  fontFamily:
                                                    "GT-Walsheim-medium",
                                                  color: "rgb(79 45 127)",
                                                }}
                                              >
                                                {prop.name}
                                              </Typography>
                                            }
                                          />
                                        </ListItem>
                                      )}
                                    </>
                                  ))}
                                </div>
                              </AccordionDetails>
                            </Accordion>
                          </div>
                        ) : (
                          <ListItem
                            key={prop.name}
                            component={Link}
                            to={prop.path}
                            style={{
                              textDecoration: "none",
                              whiteSpace: "pre-line",
                            }}
                          >
                            <ListItemText
                              primary={
                                <Typography
                                  style={{
                                    fontSize: "12px",
                                    fontFamily: "GT-Walsheim-medium",
                                    color: "rgb(79 45 127)",
                                  }}
                                >
                                  {prop.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </div>
                ) : props.module == "admin" ? (
                  props.userRole == 2 ? (
                    <div>
                      {superAdminRoutes.map(renderMenuItems)}
                    </div>
                  ) : (
                    <div>
                      {adminRoutes.map((prop, index) => (
                        <div>
                          {prop.name != "Logout" ? (
                            <div
                              className={
                                prop.path == window.location.pathname
                                  ? "sideBar-active"
                                  : ""
                              }
                            >
                              <ListItem
                                key={prop.name}
                                component={Link}
                                to={prop.path}
                                style={{
                                  textDecoration: "none",
                                  whiteSpace: "pre-line",
                                }}
                              >
                                <ListItemText
                                  primary={
                                    <Typography
                                      style={{
                                        fontSize: "13px",
                                        fontFamily: "GT-Walsheim-medium",
                                        color: "rgb(79 45 127)",
                                      }}
                                    >
                                      {prop.name}
                                    </Typography>
                                  }
                                />
                              </ListItem>
                            </div>
                          ) : (
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "13px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          )}
                        </div>
                      ))}
                    </div>
                  )
                ) : props.module == "gtaxpro_tutorial" ? '' : 
                props.module == "ims" ? (
                  <div>
                    {IMSRoutes.map((prop, index) => (
                      <div>
                        {prop.name != "Logout" ? (
                          <div
                            className={
                              prop.path == window.location.pathname
                                ? "sideBar-active"
                                : ""
                            }
                          >
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          </div>
                        ) : (
                          <ListItem
                            key={prop.name}
                            component={Link}
                            to={prop.path}
                            style={{
                              textDecoration: "none",
                              whiteSpace: "pre-line",
                            }}
                          >
                            <ListItemText
                              primary={
                                <Typography
                                  style={{
                                    fontSize: "12px",
                                    fontFamily: "GT-Walsheim-medium",
                                    color: "rgb(79 45 127)",
                                  }}
                                >
                                  {prop.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </div>
                ) :props.module == "external_links" ? (
                  <div>
                    {externalLinks.map((prop, index) => (
                      <div>
                        {prop.name != "Logout" ? (
                          <div
                            className={
                              prop.path == window.location.pathname
                                ? "sideBar-active"
                                : ""
                            }
                          >
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          </div>
                        ) : (
                          <ListItem
                            key={prop.name}
                            component={Link}
                            to={prop.path}
                            style={{
                              textDecoration: "none",
                              whiteSpace: "pre-line",
                            }}
                          >
                            <ListItemText
                              primary={
                                <Typography
                                  style={{
                                    fontSize: "12px",
                                    fontFamily: "GT-Walsheim-medium",
                                    color: "rgb(79 45 127)",
                                  }}
                                >
                                  {prop.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </div>
                ) :
                props.module == "chat_bot" ? (
                    <div>
                      {chatBotRoutes.map((prop, index) => (
                        <div>
                          {prop.name != "Logout" ? (
                            <div
                              className={
                                prop.path == window.location.pathname
                                  ? "sideBar-active"
                                  : ""
                              }
                            >
                              <ListItem
                                key={prop.name}
                                component={Link}
                                to={prop.path}
                                style={{
                                  textDecoration: "none",
                                  whiteSpace: "pre-line",
                                }}
                              >
                                {/* <ListItemIcon>
                              <img
                                src={anx1RoutesImage[index]}
                                alt="Logo"
                                style={{ width: "35px" }}
                              />
                            </ListItemIcon> */}
                                <ListItemText
                                  primary={
                                    <Typography
                                      style={{
                                        fontSize: "13px",
                                        fontFamily: "GT-Walsheim-medium",
                                        color: "rgb(79 45 127)",
                                      }}
                                    >
                                      {prop.name}
                                    </Typography>
                                  }
                                />
                              </ListItem>
                            </div>
                          ) : (
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "13px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          )}
                        </div>
                      ))}
                    </div>
                  )	
                :
                props.module == "help_support" ? (
                  <div>
                    {HelpAndSupport.map((prop, index) => (
                      <div>
                        {prop.name != "Logout" ? (
                          <div
                            className={
                              prop.path == window.location.pathname
                                ? "sideBar-active"
                                : ""
                            }
                          >
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          </div>
                        ) : (
                          <ListItem
                            key={prop.name}
                            component={Link}
                            to={prop.path}
                            style={{
                              textDecoration: "none",
                              whiteSpace: "pre-line",
                            }}
                          >
                            <ListItemText
                              primary={
                                <Typography
                                  style={{
                                    fontSize: "12px",
                                    fontFamily: "GT-Walsheim-medium",
                                    color: "rgb(79 45 127)",
                                  }}
                                >
                                  {prop.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </div>
                ) : 
                (
                  <div>
                    {gstr3bRoutes.map((prop, index) => (
                      <div>
                        {prop.name != "Logout" ? (
                          <div
                            className={
                              prop.path == window.location.pathname
                                ? "sideBar-active"
                                : ""
                            }
                          >
                            <ListItem
                              key={prop.name}
                              component={Link}
                              to={prop.path}
                              style={{
                                textDecoration: "none",
                                whiteSpace: "pre-line",
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "GT-Walsheim-medium",
                                      color: "rgb(79 45 127)",
                                    }}
                                  >
                                    {prop.name}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          </div>
                        ) : (
                          <ListItem
                            key={prop.name}
                            component={Link}
                            to={prop.path}
                            style={{
                              textDecoration: "none",
                              whiteSpace: "pre-line",
                            }}
                          >
                            <ListItemText
                              primary={
                                <Typography
                                  style={{
                                    fontSize: "12px",
                                    fontFamily: "GT-Walsheim-medium",
                                    color: "rgb(79 45 127)",
                                  }}
                                >
                                  {prop.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            
            
           
         

          </List>
          {/* { props.module !== "help_support" &&
            <Link className="help-support" to={"/gtaxpro_help_support"}>
              <IconButton
                color="inherit"
                aria-label="Help & Support"
                edge="start"
                disableRipple
                sx={{
                  marginBottom: "4px",
                  marginRight: "0.5em",
                  height: "20px",
                  "&:hover": {
                    backgroundColor: "transparent", // Disable hover effect
                  },
                  "&:focus": {
                    outline: "none", // Remove focus outline
                  },
                }}
                // ...(open && { display: "none" }),
              >
              <ErrorOutlineOutlinedIcon/>
              </IconButton>
              {open && "Help & Support"}
            </Link>
          } */}

           <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              {includeModules.includes(props.module) && (
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={handleOpenAddNotes}
                  style={{
                    backgroundColor: "#4f2d7f",
                    color: "white",
                    textTransform: "capitalize",
                    borderRadius: "15px",
                    marginLeft: "10px",
                    marginRight: "10px",
                  }}
                >
                  <CreateIcon fontSize="small" />
                  {"Add Notes"}
                </Button>
              )}
              {props.module !== "help_support" && (
            
              <Link className="help-support" to={"/external_links"}>
                <IconButton
                  color="inherit"
                  aria-label="Knowledge Hub"
                  edge="start"
                  disableRipple
                  sx={{
                    marginBottom: "4px",
                    marginRight: "0.5em",
                    height: "20px",
                    "&:hover": {
                      backgroundColor: "transparent", // Disable hover effect
                    },
                    "&:focus": {
                      outline: "none", // Remove focus outline
                    },
                  }}
                  // ...(open && { display: "none" }),
                >
                  <ErrorOutlineOutlinedIcon />
                </IconButton>
                {open && "Knowledge Hub"}
              </Link>
            )}
              {props.module !== "help_support" && (
                <Link className="help-support" to={"/gtaxpro_help_support"}>
                  <IconButton
                    color="inherit"
                    aria-label="Help & Support"
                    edge="start"
                    disableRipple
                    sx={{
                      marginBottom: "4px",
                      marginRight: "0.5em",
                      height: "20px",
                      "&:hover": {
                        backgroundColor: "transparent", // Disable hover effect
                      },
                      "&:focus": {
                        outline: "none", // Remove focus outline
                      },
                    }}
                  >
                    {/* <ErrorOutlineOutlinedIcon /> */}
                    <img src={TechnicalSupportIcon} alt="Help & Support" style={{ width: 20, height: 20 }} />

                  </IconButton>
                  {open && "Help & Support"}
                </Link>
              )}
            </div>
          </div>
        </Drawer>
      )}
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <main>{props.children}</main>
      </main>
      {includeModules.includes(props.module) && (
        <AddNotes moduleData={props.modules} module={props.module} />
      )}
    </div>
  );
}
